const events = {
  clicked: 'clicked'
} as const;

/* START OF COMPILED CODE */

import UserComponent from "./UserComponent";
import Phaser from "phaser";
/* START-USER-IMPORTS */
import { app } from '../App';
/* END-USER-IMPORTS */

export default class UIButton extends UserComponent {

  constructor(gameObject: Phaser.GameObjects.Container) {
    super(gameObject);

    this.gameObject = gameObject;
    (gameObject as any)["__UIButton"] = this;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  static getComponent(gameObject: Phaser.GameObjects.Container): UIButton {
    return (gameObject as any)["__UIButton"];
  }

  private gameObject: Phaser.GameObjects.Container;
  public btnState: boolean = true;
  public onList: (Phaser.GameObjects.Image | Phaser.GameObjects.Container)[] = [];
  public offList: (Phaser.GameObjects.Image | Phaser.GameObjects.Container)[] = [];
  public desktopVisibleList: (Phaser.GameObjects.Image | Phaser.GameObjects.Container)[] = [];
  public mobileVisibleList: (Phaser.GameObjects.Image | Phaser.GameObjects.Container)[] = [];
  public soundOn: string = "SndItemClick";
  public soundOff: string = "SndItemClick";
  public shouldPulse: boolean = false;
  public pulseDelay: number = 2000;
  public pulseScaleEnd: number = 1.05;
  public pulseSpeed: number = 400;

  /* START-USER-CODE */
  public static events = events;

  private initScaleX!: number;
  private initScaleY!: number;
  private initHitArea!: Phaser.Geom.Rectangle;
  private pulseTween: Phaser.Tweens.Tween | undefined;

  public awake() {
    this.initScaleX = this.gameObject.scaleX;
    this.initScaleY = this.gameObject.scaleY;
    this.initHitArea = new Phaser.Geom.Rectangle();

    this.togglePlatformVisuals();

    if (this.gameObject.list.length > 0) {
      let tempVector = new Phaser.Math.Vector2();

      for (let i = 0; i < this.gameObject.list.length; i++) {
        const element = this.gameObject.list[i];

        if (element instanceof Phaser.GameObjects.Image) {
          element.getBottomLeft(tempVector);
          if (tempVector.x < this.initHitArea.left) this.initHitArea.left = tempVector.x;
          if (tempVector.y > this.initHitArea.bottom) this.initHitArea.bottom = tempVector.y;

          element.getTopRight(tempVector);
          if (tempVector.x > this.initHitArea.right) this.initHitArea.right = tempVector.x;
          if (tempVector.y < this.initHitArea.top) this.initHitArea.top = tempVector.y;
        }
      }

      this.initHitArea.setPosition(0, 0);
      this.gameObject.setSize(this.initHitArea.width, this.initHitArea.height);
    }

    this.gameObject.setInteractive();
    this.gameObject.on(Phaser.Input.Events.POINTER_DOWN, () => {
      if (this.pulseTween) {
        this.pulseTween.pause();
      }

      this.scene.add.tween({
        targets: this.gameObject,
        scaleX: this.initScaleX * 0.8,
        scaleY: this.initScaleY * 0.8,
        duration: 80,
        // yoyo: true,
        onStart: () => {
          if (this.gameObject.input.hitArea instanceof Phaser.Geom.Rectangle) {
            // console.log('hitarea start', this.gameObject.input.hitArea);
            let diffWidth = this.initHitArea.width * (1 / 0.8) - this.initHitArea.width;
            let diffHeight = this.initHitArea.height * (1 / 0.8) - this.initHitArea.height;
            this.gameObject.input.hitArea.setTo(-diffWidth * 0.5, -diffHeight * 0.5, this.initHitArea.width + diffWidth, this.initHitArea.height + diffHeight);
            // console.log('hitarea start', this.gameObject.input.hitArea);
          }
        }
      });
    });

    this.gameObject.on(Phaser.Input.Events.POINTER_UP, () => {
      app.audioHandler.playSound(this.scene, this.btnState ? this.soundOn : this.soundOff, 'sfx');
      this.updateState(!this.btnState);

      this.scene.add.tween({
        targets: this.gameObject,
        scaleX: this.initScaleX,
        scaleY: this.initScaleY,
        duration: 80,
        ease: Phaser.Math.Easing.Cubic.InOut,
        // yoyo: true,
        onComplete: () => {
          this.gameObject.emit(UIButton.events.clicked);

          if (this.gameObject.input.hitArea instanceof Phaser.Geom.Rectangle) {
            // console.log('hitarea up', this.gameObject.input.hitArea);
            this.gameObject.input.hitArea.setTo(this.initHitArea.x, this.initHitArea.y, this.initHitArea.width, this.initHitArea.height);
            // console.log('hitarea up', this.gameObject.input.hitArea);
          }
        }
      });
    });

    this.gameObject.on(Phaser.Input.Events.POINTER_OUT, () => {
      this.scene.add.tween({
        targets: this.gameObject,
        scaleX: this.initScaleX,
        scaleY: this.initScaleY,
        duration: 80,
        ease: Phaser.Math.Easing.Cubic.InOut,
        // yoyo: true,
        onComplete: () => {
          if (this.gameObject.input.hitArea instanceof Phaser.Geom.Rectangle) {
            // console.log('hitarea out', this.gameObject.input.hitArea);
            this.gameObject.input.hitArea.setTo(this.initHitArea.x, this.initHitArea.y, this.initHitArea.width, this.initHitArea.height);
            // console.log('hitarea out', this.gameObject.input.hitArea);
          }

          if (this.pulseTween && this.pulseTween.isPaused()) {
            this.pulseTween.resume();
          }
        }
      });
    });

    if (this.shouldPulse) {
      this.scene.time.addEvent({ delay: this.pulseDelay, callback: this.pulseBtn, callbackScope: this });
    }
  }

  public setState(state: boolean) {
    this.updateState(state);
  }

  public ignoreCamera(camera: Phaser.Cameras.Scene2D.Camera) {
    this.gameObject.scrollFactorX = 0;
    this.gameObject.scrollFactorY = 0;
  }

  protected pulseBtn() {
    this.pulseTween = this.scene.add.tween({
      targets: this.gameObject,
      scaleX: { from: this.initScaleX, to: this.pulseScaleEnd },
      scaleY: { from: this.initScaleY, to: this.pulseScaleEnd },
      duration: this.pulseSpeed,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });
  }

  protected updateState(newState: boolean) {
    this.btnState = newState;
    this.onList.forEach((object) => object.setVisible(newState));
    this.offList.forEach((object) => object.setVisible(!newState));
  }

  protected togglePlatformVisuals() {
    this.desktopVisibleList.forEach((obj) => {
      obj.setActive(this.scene.sys.game.device.os.desktop);
      obj.setVisible(this.scene.sys.game.device.os.desktop);
    });
    this.mobileVisibleList.forEach((obj) => {
      obj.setActive(!this.scene.sys.game.device.os.desktop);
      obj.setVisible(!this.scene.sys.game.device.os.desktop);
    });
  }

  protected destroy() {
    this.gameObject.off(Phaser.Input.Events.POINTER_DOWN);
    this.gameObject.off(Phaser.Input.Events.POINTER_UP);
    this.gameObject.off(Phaser.Input.Events.POINTER_OUT);

    super.destroy();
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
